module.exports = __webpack_public_path__ + "img/stones-1.2e67fbf.png";